/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Push_FailedInputs */

const en_us2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not turn them on. Try again.`)
};

const pt_br2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para ativar. Tente de novo.`)
};

const es_419_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron activar. Inténtalo de nuevo.`)
};

const pt_pt2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível ativar. Tenta outra vez.`)
};

const fr_fr2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de les activer. Réessaie.`)
};

const de_de2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte nicht eingeschaltet werden. Versuch es noch mal.`)
};

const it_it2_profile_push_failed = /** @type {(inputs: Profile_Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile attivarle. Riprova.`)
};

/**
* | output |
* | --- |
* | "Could not turn them on. Try again." |
*
* @param {Profile_Push_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_push_failed = /** @type {((inputs?: Profile_Push_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Push_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_push_failed(inputs)
	if (locale === "es-419") return es_419_profile_push_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_push_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_push_failed(inputs)
	if (locale === "de-DE") return de_de2_profile_push_failed(inputs)
	if (locale === "it-IT") return it_it2_profile_push_failed(inputs)
	return en_us2_profile_push_failed(inputs)
});
export { profile_push_failed as "profile.push_failed" }